module.exports = __webpack_public_path__ + "static/media/jumbo_background.4f9189b5.png";